import React from 'react';
import styled from 'styled-components/macro';

import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { getTrialEndDate } from 'lib/trialDateFormatting';
import {
  PODIUM_TERMS_AND_CONDITIONS_URL,
  PODIUM_PRIVACY_POLICY_URL,
} from 'routes/constants';
import { MONTHLY_TERM } from 'screens/Trials/constants';
import { TRIAL_COLORS, TrialsLink } from 'screens/Trials/styles';

export const TrialPaymentDisclaimer = () => {
  const trialEndDate = getTrialEndDate();
  const { trialPlanTerm, trialPlan = {} } = useTrialsContext() || {};
  const { monthlyPrice, annualPrice } = trialPlan;

  return (
    <TrialPaymentDisclaimerWrapper>
      By starting a free trial, you agree to{' '}
      <TrialsLink href={PODIUM_TERMS_AND_CONDITIONS_URL} target="_blank">
        Podium Terms and Conditions,
      </TrialsLink>
      <TrialsLink href={PODIUM_PRIVACY_POLICY_URL} target="_blank">
        {' '}
        Privacy Policy,
      </TrialsLink>{' '}
      {` and these terms: You can cancel your 14-day free trial 
          anytime before ${trialEndDate}. If you don't cancel (Settings > 
          Billing) by that date, your trial will become a ${trialPlanTerm} subscription, 
          and your credit/debit card will be charged $${
            trialPlanTerm === MONTHLY_TERM ? monthlyPrice : annualPrice
          }/${trialPlanTerm === MONTHLY_TERM ? 'month' : 'year'} + 
          taxes until you cancel.`}
    </TrialPaymentDisclaimerWrapper>
  );
};

const TrialPaymentDisclaimerWrapper = styled.small`
  color: ${TRIAL_COLORS.lightGreyText};
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 24px;
`;

export default TrialPaymentDisclaimer;
